import React from 'react';

import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';

import { ErrorMessageDialog } from '~/components/ErrorMessageDialog';
import { ResponseError } from '~/domain/ResponseError';
import { useTrigger } from '~/hooks/useTrigger';

interface IErrorMessage {
  error?: ResponseError | Error | null;
}

export const ErrorMessage: React.FC<IErrorMessage> = (props) => {
  const { error } = props;
  const [showDetails, detailsHook] = useTrigger();

  if (!error) {
    return null;
  }

  const { message } = error as Partial<ResponseError>;

  return (
    <>
      <Alert
        variant="outlined"
        severity="error"
        sx={{
          'margin-right': '8px',
        }}
      >
        {message}
        <Link
          sx={{
            'margin-left': '8px',
            cursor: 'pointer',
          }}
          onClick={detailsHook.activate}
        >
          + details
        </Link>
      </Alert>
      {showDetails && (
        <ErrorMessageDialog error={error} onClose={detailsHook.deactivate} />
      )}
    </>
  );
};
